/**
 * Code-Stand: ThreeJS r127
 */
/**
 * @author mrdoob / http://mrdoob.com/
 */

function TextureLoader(manager) {

	THREE.Loader.call( this, manager );

}

TextureLoader.prototype = Object.assign( Object.create( THREE.Loader.prototype ), {

	constructor: TextureLoader,

    load: function (url, onLoad, onProgress, onError) {

		const texture = new THREE.Texture();

        const loader = new THREE.ImageLoader(this.manager);

        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);

        loader.load(url, image => {

            texture.image = image;

            // JPEGs can't have an alpha channel, so memory can be saved by storing them as RGB.
            const isJPEG = url.search( /\.jpe?g($|\?)/i ) > 0 || url.search( /^data\:image\/jpeg/ ) === 0;

            texture.format = isJPEG ? THREE.RGBFormat : THREE.RGBAFormat;
            texture.needsUpdate = true;

            if (onLoad !== undefined) {
                onLoad(texture);
            }

            // PATCHED ------------------------------------------------------------------
            if (texture.promise) {
                texture.promiseResolve(texture);
            }
            // --------------------------------------------------------------------------

        }, onProgress,
        // PATCHED ------------------------------------------------------------------
        error => {

            if (texture.promise) {
                texture.promiseReject(texture);
            }

            if (onError !== undefined) {
                onError(error);
            }
        });
        // --------------------------------------------------------------------------

        return texture;

    }

});

THREE.TextureLoader = TextureLoader;
